import { createSelector } from "reselect";
import type { CustomDashboard } from "single-spa/store/types";

const currentDashboardSelector = (state: { customDashboard: CustomDashboard }) =>
    state.customDashboard.currentDashboard;

export const widgetsLoadedSelector = createSelector([currentDashboardSelector], (currentDash) => {
    return currentDash.widgetsLoaded;
});
